import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
    static targets = ["card", "badge"]

    start() {
        // Optimistic UI: fade + disable interactions immediately
        this.cardTarget.classList.add("opacity-50", "pointer-events-none")
        if (this.hasBadgeTarget) this.badgeTarget.classList.remove("hidden")
    }

    end(event) {
        // If server errors, revert UI
        if (!event.detail.success) {
            this.cardTarget.classList.remove("opacity-50", "pointer-events-none")
            if (this.hasBadgeTarget) this.badgeTarget.classList.add("hidden")
            Swal.fire({
                icon: "error",
                title: "Couldn’t discard invitation",
                text: "Please try again.",
                confirmButtonText: "OK",
                customClass: {
                    popup: "swal2-ea-popup",
                    title: "swal2-ea-title",
                    confirmButton: "swal2-ea-confirm"
                },
                buttonsStyling: false
            })
        }
        // On success, Turbo Stream will replace the card with the final state anyway.
    }
}
